import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 20C11.7167 20 11.4793 19.904 11.288 19.712C11.096 19.5207 11 19.2834 11 19V7.82505L6.12499 12.7C5.92499 12.9 5.68733 13 5.41199 13C5.13733 13 4.89999 12.9 4.69999 12.7C4.49999 12.5 4.39999 12.2667 4.39999 12C4.39999 11.7334 4.49999 11.5 4.69999 11.3L11.3 4.70005C11.4 4.60005 11.5083 4.52905 11.625 4.48705C11.7417 4.44572 11.8667 4.42505 12 4.42505C12.1333 4.42505 12.2627 4.44572 12.388 4.48705C12.5127 4.52905 12.6167 4.60005 12.7 4.70005L19.3 11.3C19.5 11.5 19.6 11.7334 19.6 12C19.6 12.2667 19.5 12.5 19.3 12.7C19.1 12.9 18.8623 13 18.587 13C18.3123 13 18.075 12.9 17.875 12.7L13 7.82505V19C13 19.2834 12.9043 19.5207 12.713 19.712C12.521 19.904 12.2833 20 12 20Z",
		fill: "currentColor"
	})
});
export default SvgArrowUp;
